import createWrappedField from './createWrappedField'

import DP from '../DatePicker'

export default createWrappedField({
  Component: DP,
  name: 'DDIDatePicker'
})
